<template>
  <v-app style="background-color: #DBDBDB">
    <notifications position="top center" />
    <vue-headful :title="$t('app.title', { companyName: this.companyName })" />
    <v-main id="main-view">
      <top-bar-header v-if="showSidebar" />
      <v-container fluid fill-height :class="full ? 'pa-0' : 'px-10'">
        <navigation v-if="showSidebar" :displayName="meDisplayName"/>
        <router-view id="main-router-view" :class="full ? 'ma-0 full' : ''" />
      </v-container>
      <version />
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import { initLocale } from '@/mixins/language.mixins';
import { initBookingChannel, bookingChannelComputed } from '@/mixins/bookingChannel.mixins';
import Navigation from '@/components/navigation/Navigation.vue';
import TopBarHeader from '@/components/navigation/TopBarHeader.vue';
import { getMe } from '@/mixins/users.mixins';
import Version from './components/Version.vue';

export default {
  components: { Navigation, TopBarHeader, Version },
  mixins: [initLocale, initBookingChannel, bookingChannelComputed, getMe],
  async mounted() {
    await this.$store.dispatch('users/getUserRole');
  },
  computed: {
    ...mapGetters('authentication', ['idToken']),
    showSidebar() {
      return this.$route.meta?.sidebar;
    },
    full() {
      return this.$route.meta?.full;
    },
  },
  watch: {
    idToken() {
      this.$store.dispatch('users/getUserRole');
    },
  }
};
</script>

<style lang="sass" scoped>
#main-view
  overflow-y: hidden

#main-router-view
  height: 100%
  width: 100%

#main-router-view.full
  max-width: initial
</style>
